import React from "react";

/**
 * Renders a schedule page component with additional props.
 * Kept for call-site compatibility after the React Router v6 migration.
 */
export default function ScheduleEditRoute({
  component: Component,
  additionalProps = {},
}) {
  return <Component {...additionalProps} />;
}
